/**
 * NovaDetective — "Detective" persona tile. On the case. The case: where did the pancake go?
 * Timing: 3s glass sway · 3.5s clue blink. Geometry generated from the canonical Character
 * Bible catalog (nova.js) — regenerate rather than hand-editing paths.
 * Animations come from nova.css via the `expr-detective` wrapper class
 * (applied by <NovaExpression id="detective" />).
 */
import * as React from "react";

export function NovaDetective({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nova the detective">
      
        
      <defs>
        <linearGradient id="bodyG-n8" x1="0.15" y1="0" x2="0.85" y2="1">
          <stop offset="0" stopColor="#709c9e"/>
          <stop offset="0.45" stopColor="#2D6E70"/>
          <stop offset="1" stopColor="#1e494a"/>
        </linearGradient>
        <linearGradient id="chestG-n8" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#174143"/>
          <stop offset="1" stopColor="#3a6b6d"/>
        </linearGradient>
        <radialGradient id="scrG-n8" cx="0.5" cy="0.45" r="0.8">
          <stop offset="0" stopColor="#0E1626"/>
          <stop offset="0.72" stopColor="#0E1626"/>
          <stop offset="1" stopColor="#060A12"/>
        </radialGradient>
        <pattern id="pxg-n8" width="9" height="9" patternUnits="userSpaceOnUse">
          <path d="M 9 0 L 0 0 0 9" fill="none" stroke="#060A12" strokeWidth="1.6" opacity="0.65"/>
        </pattern>
        <filter id="eglow-n8" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="6"/>
        </filter>
      </defs>
        <g transform="translate(50 0)">
        
        
        <g className="nova-body" style={{ transformOrigin: "180.00px 472.00px" }} transform="rotate(0 180 347)">
          {/* Antenna stem (drawn first so head covers its base) */}
          <line x1="180" y1="122" x2="180" y2="42.60000000000001" stroke="#1C1A17" strokeWidth="2.2" strokeLinecap="round"/>
          {/* Orbital ring (behind ball, ivory) */}
          <ellipse cx="180" cy="42.60000000000001" rx="15" ry="5.3999999999999995" stroke="#F4EFE6" strokeWidth="1.6" fill="none" transform="rotate(-12 180 42.60000000000001)"/>
          {/* Antenna ball */}
          <circle className="antenna-ball" cx="180" cy="42.60000000000001" r="7" fill="#D4541F"/>
          <ellipse cx="177.9" cy="40.150000000000006" rx="2.94" ry="2.1" fill="#FFFFFF" opacity="0.55"/>
          {/* Front half of orbital ring (over ball) so it appears to encircle */}
          <path d="M 165.3 43.10000000000001 A 15 5.3999999999999995 -12 0 0 194.7 40.400000000000006"
                stroke="#F4EFE6" strokeWidth="1.6" fill="none" opacity="0.95"/>
          
    
          {/* HEAD outer (glossy) */}
          <rect x="60" y="110" width="240" height="170" rx="36" fill="url(#bodyG-n8)"/>
          {/* Bezel inset (darker ring) */}
          <rect x="82" y="132" width="196" height="126" rx="28" fill="#1F5759"/>
          {/* Face screen: recessed navy display */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#scrG-n8)"/>
    
          {/* Cheeks (on teal head, flanking screen) */}
          
    
          {/* Eyes: glow pass + sharp pass */}
          <g filter="url(#eglow-n8)" opacity="0.75">
          
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 151.00 169.48 Q 154.46 164.58 155.23 170.53 L 162.26 225.38 Q 163.02 231.33 157.20 229.88 L 121.39 220.95 Q 115.57 219.50 119.04 214.61 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 204.77 170.53 Q 205.54 164.58 209.00 169.48 L 240.96 214.61 Q 244.43 219.50 238.61 220.95 L 202.80 229.88 Q 196.98 231.33 197.74 225.38 Z" fill="#A8C8E8" opacity="1"/></g>
        </g>
          
          
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 151.00 169.48 Q 154.46 164.58 155.23 170.53 L 162.26 225.38 Q 163.02 231.33 157.20 229.88 L 121.39 220.95 Q 115.57 219.50 119.04 214.61 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 204.77 170.53 Q 205.54 164.58 209.00 169.48 L 240.96 214.61 Q 244.43 219.50 238.61 220.95 L 202.80 229.88 Q 196.98 231.33 197.74 225.38 Z" fill="#A8C8E8" opacity="1"/></g>
        
    
          {/* Single quiet tear (Sad) — on face screen, below right eye */}
          
    
          {/* Pixel grid over the display (LED look) */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#pxg-n8)"/>
          {/* Screen glare */}
          <ellipse cx="146.88" cy="148" rx="55.199999999999996" ry="9" fill="#8FB4E8" opacity="0.13"/>
          {/* Head specular */}
          <ellipse cx="112" cy="126" rx="36" ry="9" fill="#FFFFFF" opacity="0.35" transform="rotate(-10 112 126)"/>
    
          {/* BODY outer (glossy) */}
          <rect x="50" y="302" width="260" height="170" rx="36" fill="url(#bodyG-n8)"/>
          {/* Chest storage: interior + items behind a hinged door */}
          <rect x="72" y="324" width="216" height="126" rx="26" fill="#0B1220"/>
          <g className="chest-items" style={{ opacity: "0" }}>
            <path d="M 141.12 358 l 6.2 12.7 13.9 2 -10 9.8 2.4 13.9 -12.5 -6.6 -12.5 6.6 2.4 -13.9 -10 -9.8 13.9 -2 Z" fill="#D4A02C"/>
            <g transform="translate(190.8 368)">
              <rect x="0" y="0" width="44" height="30" rx="5" fill="#1C1A17"/>
              <circle cx="22" cy="15" r="9" fill="#3A3733" stroke="#F4EFE6" strokeWidth="1.4"/>
              <rect x="31" y="3" width="8" height="5" rx="1.5" fill="#3A3733"/>
            </g>
          </g>
          {/* Chest door (hinged at left edge) */}
          <g className="chest-door" style={{ transformOrigin: "74px 387.0px" }}>
            <rect x="72" y="324" width="216" height="126" rx="26" fill="url(#chestG-n8)"/>
            <line x1="79" y1="336" x2="79" y2="438" stroke="#0B1220" strokeWidth="2.4" opacity="0.55"/>
            <circle cx="272" cy="387.0" r="5" fill="#6d9293"/>
          </g>
          {/* Body specular */}
          <ellipse cx="98" cy="316" rx="30" ry="7" fill="#FFFFFF" opacity="0.25" transform="rotate(-8 98 316)"/>
    
          {/* Arms (drawn over body) */}
          
        </g>
        </g>
      
      <g transform="translate(50 0)">
        {/* arm holding magnifying glass up near the screen */}
        <path d="M 300 310 Q 330 290 344 268" stroke="#1C1A17" strokeWidth="11" strokeLinecap="round" fill="none"/>
        <g className="det-glass">
          <line x1="296" y1="242" x2="342" y2="286" stroke="#1C1A17" strokeWidth="11" strokeLinecap="round"/>
          <circle cx="272" cy="218" r="44" fill="#A8C8E8" opacity="0.22"/>
          <circle cx="272" cy="218" r="44" fill="none" stroke="#1C1A17" strokeWidth="9"/>
          <path d="M 248 196 A 32 32 0 0 1 272 186" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" fill="none" opacity="0.6"/>
        </g>
      </g>
      {/* floating question marks (outer coords) */}
      <g fontFamily="Jost, sans-serif" fontWeight="600" fill="#D4A02C">
        <text className="det-q" x="392" y="130" fontSize="46">?</text>
        <text className="det-q q2" x="424" y="196" fontSize="32">?</text>
      </g>
    </svg>
  );
}
